import * as req from 'api/actions';
import * as c from './constant';

export const getCalendarEntriesList = (payload, callback) =>
  req.list(
    c.GET_CALENDAR_ENTRIES_LIST,
    'api/v1/administrators/calendar_holidays',
    payload,
    callback
  );

export const showCalendarEntry = (id, payload, callback) =>
  req.item(
    c.SHOW_CALENDAR_ENTRIES,
    `api/v1/administrators/calendar_holidays/${id}`,
    payload,
    callback
  );

export const createCalendarEntries = (payload, callback) =>
  req.create(
    c.CREATE_CALENDAR_ENTRIES,
    'api/v1/administrators/calendar_holidays',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateCalendarEntries = (id, payload, callback) =>
  req.update(
    c.UPDATE_CALENDAR_ENTRIES,
    `api/v1/administrators/calendar_holidays/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const deleteCalendarEntries = (id, payload, callback) =>
  req.remove(
    c.DELETE_CALENDAR_ENTRIES,
    `api/v1/administrators/calendar_holidays/${id}`, // url
    payload,
    callback
  );
